import React from 'react';
import PropTypes from 'prop-types';

/**
 * AgentInformationSection Component
 * Form section for agent details
 */
const AgentInformationSection = ({ formData, onInputChange, styles }) => {
  return (
    <div style={styles.column}>
      <div style={styles.columnHeader}>Agent Information</div>

      <div style={styles.formGrid}>
        {/* First Name */}
        <div style={styles.formGroup} data-itemid='agent-firstName-wrapper'>
          <label style={styles.label} data-itemid='agent-firstName-label'>
            First Name
          </label>
          <input data-itemid='agent-firstName-field' onChange={e => onInputChange('firstName', e.target.value)} placeholder='' style={styles.input} type='text' value={formData.firstName || ''} />
        </div>

        {/* Last Name */}
        <div style={styles.formGroup} data-itemid='agent-lastName-wrapper'>
          <label style={styles.label} data-itemid='agent-lastName-label'>
            Last Name
          </label>
          <input data-itemid='agent-lastName-field' onChange={e => onInputChange('lastName', e.target.value)} placeholder='' style={styles.input} type='text' value={formData.lastName || ''} />
        </div>

        {/* Email */}
        <div style={styles.formGroup} data-itemid='agent-email-wrapper'>
          <label style={styles.label} data-itemid='agent-email-label'>
            Email
          </label>
          <input data-itemid='agent-email-field' onChange={e => onInputChange('agentEmail', e.target.value)} placeholder='' style={styles.input} type='email' value={formData.agentEmail || ''} />
        </div>

        {/* Phone */}
        <div style={styles.formGroup} data-itemid='agent-phone-wrapper'>
          <label style={styles.label} data-itemid='agent-phone-label'>
            Phone
          </label>
          <input data-itemid='agent-phone-field' onChange={e => onInputChange('agentPhone', e.target.value)} placeholder='' style={styles.input} type='tel' value={formData.agentPhone || ''} />
        </div>

        {/* License Number */}
        <div style={styles.formGroup} data-itemid='agent-license-wrapper'>
          <label style={styles.label} data-itemid='agent-license-label'>
            License Number
          </label>
          <input
            data-itemid='agent-license-field'
            onChange={e => onInputChange('agentLicenseNumber', e.target.value)}
            placeholder=''
            style={styles.input}
            type='text'
            value={formData.agentLicenseNumber || ''}
          />
        </div>
      </div>
    </div>
  );
};

AgentInformationSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired
};

export default AgentInformationSection;
